const CANONICAL_QUESTION_BASE = '/find-my-part/questions';

/**
 * Build the crawlable canonical question URL used by every public widget row.
 * Encoding the server-projected slug prevents an unexpected slash or query
 * delimiter from escaping the canonical question path.
 */
export function canonicalQuestionHref(
  slug: string,
  baseUrl: string = CANONICAL_QUESTION_BASE
): string {
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  return `${normalizedBase}/${encodeURIComponent(slug)}/`;
}
